import { Form, type InferType, TextField, useForm, yup, yupResolver } from 'form';
import { Button } from 'ui';

const schema = yup.object().shape({
  email_verification_code: yup
    .string()
    .matches(/^[0-9]+$/, 'Must be only digits')
    .required('One-time passcode is required')
    .min(4, 'One-time passcode must be 4 digits')
    .max(4, 'One-time passcode must be 4 digits'),
});

export type OtpFormValues = InferType<typeof schema>;

export const OtpForm = ({ onSubmit, isLoading }: { isLoading: boolean; onSubmit: (data: OtpFormValues) => void }) => {
  const form = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <Form {...form} onSubmit={onSubmit} data-testid="otp-form">
      <TextField
        type="text"
        name="email_verification_code"
        size="medium"
        label="Passcode"
        required
        autoFocus
        fullWidth
      />
      <Button type="submit" size="large" loading={isLoading}>
        Sign in
      </Button>
    </Form>
  );
};
